import type { CSSProperties } from 'react';

/**
 * The public pages' type scale: the sizes /ai-story-generator uses (its
 * design's H1 3.1rem, H2 2.1rem, H3 1.25rem and 1.15rem intros, fluid down to
 * phone size), so the landing page, pricing, the gallery, the storybook pages
 * and the two generator pages all read at one size.
 *
 * For inline styles: spread a preset and add the element's own spacing,
 * e.g. style={{ ...H2, margin: '0 0 8px' }}.
 */

export const SERIF = "'Newsreader',serif";

export const TYPE = {
    /** 32px on phones → 49.6px on desktop */
    h1: 'clamp(2rem, 1.5rem + 2.2vw, 3.1rem)',
    /** 24px → 33.6px */
    h2: 'clamp(1.5rem, 1.3rem + 1vw, 2.1rem)',
    /** 17px → 20px: card and feature titles */
    h3: 'clamp(1.05rem, 1rem + .3vw, 1.25rem)',
    /** 16.3px → 18.4px: intros under a heading */
    lead: 'clamp(1.02rem, .97rem + .25vw, 1.15rem)',
    /** Body text in a wide block */
    body: '16px',
    /** Text inside cards */
    text: '14.4px',
    /** Small titles: tiles, compact cards */
    title: '15.7px',
    /** Small uppercase labels above a heading */
    eyebrow: '12.2px',
    /** FAQ question / answer */
    faqQ: '15.4px',
    faqA: '14.7px',
} as const;

export const H1: CSSProperties = { fontFamily: SERIF, fontWeight: 600, fontSize: TYPE.h1, lineHeight: 1.15, letterSpacing: '-0.01em' };
export const H2: CSSProperties = { fontFamily: SERIF, fontWeight: 600, fontSize: TYPE.h2, lineHeight: 1.15, letterSpacing: '-0.01em' };
export const H3: CSSProperties = { fontFamily: SERIF, fontWeight: 600, fontSize: TYPE.h3, lineHeight: 1.25 };
/** A small serif title (tiles, compact cards) */
export const TITLE: CSSProperties = { fontFamily: SERIF, fontWeight: 600, fontSize: TYPE.title, lineHeight: 1.3 };
export const LEAD: CSSProperties = { fontSize: TYPE.lead, lineHeight: 1.6, color: '#6E7275' };
export const EYEBROW: CSSProperties = { fontSize: TYPE.eyebrow, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' };
